import {createContext, useContext, useState} from "react";

const StateContext = createContext();

export const ContextProvider = ({children}) => {
    const [main, setMain] = useState("eng");
    const [bookmarkJumpRequest, setBookmarkJumpRequest] = useState(0);

    const requestBookmarkJump = () => {
        setBookmarkJumpRequest(prev => prev + 1);
    };

    return (
        <StateContext.Provider
            value={{
                main,
                setMain,
                bookmarkJumpRequest,
                requestBookmarkJump
            }}
        >
            {children}
        </StateContext.Provider>
    );
};

export const useStateContext = () => useContext(StateContext);